module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.a5a5130.woff2";